import { PrimaryStatus, SecondaryStatus } from 'types/api/responses';

export const comisionistPrimaryStatusLabels: Record<PrimaryStatus, string> = {
  New: 'NUEVO',
  Active: 'ACTIVO',
  Inactive: 'INACTIVO',
};

export const comisionistSecondaryStatusLabels: Record<SecondaryStatus, string> = {
  PendingVerification: 'Pend. Verificación',
  PendingDocuments: 'Pend. Documentos',
  DocsOK: 'Docs Ok',
};

export type ComisionistStatusChipStyle = {
  backgroundColor: string;
  color: string;
  border?: string;
};

export const getComisionistPrimaryStatusStyle = (
  status: PrimaryStatus,
): ComisionistStatusChipStyle => {
  switch (status) {
    case 'New':
      return { backgroundColor: '#1976d260', color: '#19317c' };
    case 'Active':
      return { backgroundColor: '#b6edc3', color: '#225b25' };
    case 'Inactive':
      return { backgroundColor: '#757575', color: '#ffffff' };
    default:
      return { backgroundColor: '#757575', color: '#ffffff' };
  }
};

export const getComisionistSecondaryStatusStyle = (
  status: SecondaryStatus,
): ComisionistStatusChipStyle => {
  switch (status) {
    case 'PendingVerification':
      return { backgroundColor: '#FFFDE7 ', color: '#E65100  ' };
    case 'PendingDocuments':
      return { backgroundColor: '#fbebeb', color: '#a62b35' };
    case 'DocsOK':
      return {
        backgroundColor: '#e8f5e9',
        color: '#2e7d32',
        border: '1px solid #2e7d32',
      };
    default:
      return { backgroundColor: '#757575', color: '#ffffff' };
  }
};

export const comisionistStatusChipSx = {
  fontWeight: 600,
  fontSize: '12px',
  borderRadius: '20px',
  height: '26px',
};
